import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {UserModel} from '../models/UserModel'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  SetUser: '[Set User] Action',
}

const initialAuthState: IAuthState = {
  user: undefined,
}

export interface IAuthState {
  user?: UserModel
}

export const reducer = persistReducer(
  {storage, key: 'fleksUp', whitelist: ['user']},
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
        const user = action.payload?.user
        return {user}
      }

      case actionTypes.Register: {
        const user = action.payload?.user
        return {user}
      }

      case actionTypes.Logout: {
        return initialAuthState
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (user: UserModel) => {
    return {
      type: actionTypes.Login,
      payload: {
        user,
      },
    }
  },
  register: (user: UserModel) => {
    return {
      type: actionTypes.Register,
      payload: user,
    }
  },
  logout: () => ({type: actionTypes.Logout}),
  setUser: (user: UserModel) => ({type: actionTypes.SetUser, payload: {user}}),
}

export function* saga() {}
